import React from 'react';
import { Image as ImageIcon } from 'lucide-react';

// Colours match the tags offered by the annotator, so a box here reads the same
// as it did when it was drawn.
const TAG_COLORS = {
  'lens masking error': '#ef4444',
  'logo error': '#f59e0b',
  'background error': '#3b82f6',
  'lens removal error': '#3bf64e',
};

export const colorForTag = (tag) => TAG_COLORS[tag] || '#6b7280';

/**
 * An image with its rejection boxes drawn on top.
 *
 * bbox values are 0-1 fractions of the image, so they position directly as
 * percentages and stay correct at any rendered size.
 */
function AnnotatedImage({ imageUrl, annotations = [], alt = '', className = '' }) {
  if (!imageUrl) {
    return (
      <div className={`flex flex-col items-center justify-center gap-2 text-gray-400 bg-gray-50 ${className}`}>
        <ImageIcon className="w-10 h-10" />
        <span className="text-xs">No image available</span>
      </div>
    );
  }

  return (
    <div className={`relative inline-block ${className}`}>
      <img src={imageUrl} alt={alt} className="block max-w-full max-h-full object-contain" />
      {annotations.map((a, i) => {
        const b = a?.bbox;
        if (!b) return null;
        const color = colorForTag(a.tag);
        return (
          <div
            key={i}
            className="absolute pointer-events-none"
            style={{
              left: `${(b.x || 0) * 100}%`,
              top: `${(b.y || 0) * 100}%`,
              width: `${(b.width || 0) * 100}%`,
              height: `${(b.height || 0) * 100}%`,
              border: `2px solid ${color}`,
              boxShadow: '0 0 0 1px rgba(0,0,0,0.35)',
            }}
          >
            <span
              className="absolute -top-5 left-0 px-1 py-0.5 text-[10px] font-semibold text-white rounded whitespace-nowrap"
              style={{ backgroundColor: color }}
            >
              {a.tag || 'issue'}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default AnnotatedImage;
